import { render } from "./GroupPhotoProductItem.vue?vue&type=template&id=7f85dd8e&scoped=true"
import script from "./GroupPhotoProductItem.vue?vue&type=script&lang=js"
export * from "./GroupPhotoProductItem.vue?vue&type=script&lang=js"

import "./GroupPhotoProductItem.vue?vue&type=style&index=0&id=7f85dd8e&scoped=true&lang=css"

import exportComponent from "/home/rosenfeldt/projects/rosenfeldt/public_html/webshop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f85dd8e"]])

export default __exports__